module.exports = __webpack_public_path__ + "f8348739b21ffce2458926da496c0f36.MP3";